export default defineNuxtPlugin(() => {
  const { $domain, $flags } = useNuxtApp();
  if (!$domain.luigiScript || !$flags?.has('luigisbox')) {
    return;
  }

  useHead({
    script: [
      {
        'src': $domain.luigiScript ?? '',
        'data-usercentrics': 'Luigi’s Box',
        'type': 'text/plain',
        'defer': true,
        'async': true,
      },
    ],
  });
});
